export default {
  clusterLayerId: 'cluster_points',
  provincesLayerId: 'provinces_polygons',
  gridsLayerId: 'grid_polygons',
  postalcodesLayerId: 'postal_polygons',
  markerLayerId: 'shop_marker',
  competitorsLayerId: 'competitorsLayerId'
}
